import { forwardRef, type Ref, type SVGProps } from "react";

function SvgShiftBooked(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#shift_booked_inverted_svg__a)">
        <circle
          cx={88}
          cy={60}
          r={50}
          stroke="url(#shift_booked_inverted_svg__b)"
          strokeWidth={20}
        />
        <path
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="m73.556 62.576 9.333 9.545 21.778-25.454"
        />
      </g>
      <path
        fill="#ADF3C7"
        d="M29.975 2.975a.975.975 0 1 0-1.95 0c0 4.056-.895 6.754-2.595 8.455-1.7 1.7-4.399 2.595-8.455 2.595a.975.975 0 1 0 0 1.95c4.056 0 6.754.895 8.455 2.595 1.7 1.7 2.595 4.399 2.595 8.455a.975.975 0 1 0 1.95 0c0-4.056.895-6.754 2.595-8.455 1.7-1.7 4.399-2.595 8.455-2.595a.975.975 0 1 0 0-1.95c-4.056 0-6.754-.895-8.455-2.595-1.7-1.7-2.595-4.399-2.595-8.455"
      />
      <defs>
        <linearGradient
          id="shift_booked_inverted_svg__b"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="shift_booked_inverted_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgShiftBooked);
export default ForwardRef;
